import {ManifestrMissedBatchListDto} from '../dto/manifestr-missed-batch.dto';
import {ManifestrMissedBatch} from '../model/manifestr-missed-batch';

export function convertManifestrMissedBatchListDtoToModel(dto: ManifestrMissedBatchListDto): ManifestrMissedBatch[] {
  return (dto?.MissedBatches || []).map(batch => ({
    batchId: batch.BatchID,
    originId: batch.OriginID,
    originDescription: batch.OriginDescription,
    originLabel: batch.OriginLabel,
    facilityCode: batch.Facility,
    inductionDate: batch.InductionDate,
    totalPieces: batch.TotalPieces,
    totalWeightLbs: batch.TotalLbs,
    reason: batch.Reason,
  }));
}
